import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'input-field',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './input-field.component.html',
  styleUrl: './input-field.component.scss'
})
export class InputFieldComponent implements OnInit {
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() formControlName!: string;
  @Input() type?: string;
  @Input() suffix: string = '';
  @Input() inputFormControl!: FormControl;
  @Input() initialValue?: string;
  @Input() readonly!: boolean
  @Input() validationErrors?: any;
  @Input() showWarning: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  ngOnInit() {
    if (this.initialValue !== undefined) {
      this.inputFormControl.setValue(this.initialValue, { emitEvent: false });
    }
  }

  onValueChange(value: any): void {
    this.valueChange.emit(value.value);
  }

}